import { AccordianGroup as Accordians, AccordianGroupProps } from '@gositeinc/ui'

export const AccordianGroup = ({ data }: AccordianGroupProps): JSX.Element => {
  return (
    <Accordians data={data} />
  )
}
